// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"225eb4e7","194":"e209d737","239":"ab4a4fc8","353":"5144e102","424":"0ca5fb40","444":"f70b64de","582":"8b0d06c8","681":"db38d619","696":"da02381b","957":"8fbed896","966":"c6cacfb1","980":"072de08e","981":"0e755d2e"}[chunkId] + ".chunk.js";
};